import React from "react";
import PickDate from "./DatePicker";

/**
 * Registration DatePicker wrapper with vehicle registration expiry defaults
 * (future dates from +24h onwards, default label "Registration Expiry Date").
 */
function PickDateReg({
  label = "Registration Expiry Date",
  minDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
  ...props
}) {
  return <PickDate label={label} minDate={minDate} {...props} />;
}

export { PickDateReg, PickDateReg as DatePickerReg };
export default PickDateReg;
